export enum AsyncStatus {
  idle,
  pending,
  resolved,
  rejected,
}
